<template>
  <div>
    <div class="columns">
      <div class="column   section">
        <h1 class="title">Login</h1>
         <!-- <s-login/> -->
        <p class="is-size-5 has-text-danger">
          <git-footer />
        </p>
      </div>
       
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import {SLogin} from "../components";

 

export default {
  name: "Login",

  data() {
    return { 
    };
  },
  components: {
  //  's-login':SLogin,
  }
};
</script>
